import React, { useState } from 'react';
import VehiclesTable from '../../components/VehiclesTable/';
import useVehicles from '../../hooks/useVehicles';
import TripsView from './Trips';
import Template from '../../components/Template';
import Row from 'react-bootstrap/Row';

import { withTranslation } from 'react-i18next';


function VehiclesView(props) {
    const { t } = props;
    const { vehicles, loading } = useVehicles();
    const [idPlate, setIdPlate] = useState(null);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const handleBack = () => setSelectedVehicle(null);

    if (selectedVehicle) return <TripsView idPlate={selectedVehicle.id} plate={selectedVehicle.plate} onBack={handleBack} titleTranslate={t}/>;

    return (
        <Template
            type={4}
            classNameContainer="maintenance"
            className="container_menu maintenance driver"
        >

            <div className="content_dynamic history company-block block-job-requests">
                <Row className="content_maintenace">
                    <div className="header-content">
                        <div className="info-tittle">
                            <h1 className="title-maintenances">{t('Listado de Vehículos')}</h1>
                        </div>
                    </div>
                </Row>

                <VehiclesTable vehicles={vehicles} loading={loading} onSelect={setSelectedVehicle} titleTranslate={t}/>

            </div>
        </Template>
    );

}

export default withTranslation(['driverRegistration', 'alert', 'alt', 'routers'])(VehiclesView);